import { createFileRoute } from '@tanstack/react-router'
import AuthPage, { type AuthSearch } from '@/components/auth/AuthPage'
import RouteErrorScreen from '@/components/RouteErrorScreen'

export const Route = createFileRoute('/signup')({
  validateSearch: (search: Record<string, unknown>): AuthSearch => ({
    invitationcode: typeof search.invitationcode === 'string' ? search.invitationcode : undefined,
    __clerk_ticket: typeof search.__clerk_ticket === 'string' ? search.__clerk_ticket : undefined,
    showSubModal: typeof search.showSubModal === 'string' ? search.showSubModal : undefined,
    redirectTo: typeof search.redirectTo === 'string' ? search.redirectTo : undefined,
  }),
  component: SignUpRoute,
  errorComponent: RouteErrorScreen,
})

function SignUpRoute() {
  const search = Route.useSearch()
  return <AuthPage mode="signup" search={search} />
}

